import { useOrganizationStore } from "@/stores/useOrganizationStore";

export const useCurrentOrganizationId = () =>
  useOrganizationStore((s) => s.selectedOrganizationUuid ?? "");
